import React from "react"

import {
  FaHome,
  FaListUl,
  FaLock,
  FaUnlock,
  FaUser,
  FaUserPlus,
} from "../../../AppReactIcons"
import {
  Login_InternalLink,
  Logout_InternalLink,
  MyDashboard_InternalLink,
  Profile_InternalLink,
  Signup_InternalLink,
} from "../../../utils/urls"
import {
  LoginButtonWrapper,
  LogoutButtonWrapper,
  MyDashboardButtonWrapper,
  ProfileButtonWrapper,
  RedAppButton,
  SignUpButtonWrapper,
} from "../../buttons"
import { iNavSidebarLink } from "../../types"

const NavbarLinksWrapper: React.FC<{
  children: (navbarLinks: iNavSidebarLink[]) => any
}> = ({ children }) => {
  const NavbarLinks: iNavSidebarLink[] = [
    {
      title: "My Profile",
      to: Profile_InternalLink,
      external: false,
      Icon: <FaUser />,
      wrapper: ProfileButtonWrapper,
    },
    {
      title: "Home",
      to: "/",
      external: false,
      Icon: <FaHome />,
    },
    /*{
      title: "About",
      to: "/about",
      external: false,
      Icon: <FaInfoCircle />,
    },*/
    {
      title: "Topics",
      to: "/topics",
      external: false,
      Icon: <FaListUl />,
    },
    {
      title: "Log in",
      to: Login_InternalLink,
      external: false,
      Icon: <FaUnlock />,
      wrapper: LoginButtonWrapper,
    },
    {
      title: "Sign up",
      to: Signup_InternalLink,
      external: false,
      Icon: <FaUserPlus />,
      wrapper: SignUpButtonWrapper,
    },
    {
      title: "My Dashboard",
      to: MyDashboard_InternalLink,
      external: false,
      Icon: <FaUser />,
      wrapper: MyDashboardButtonWrapper,
    },
    /*{
      title: "Discussion Forum",
      to: DiscussionForum_InternalLink,
      external: false,
    },*/
    {
      title: "Log out",
      to: Logout_InternalLink,
      external: false,
      Icon: <FaLock />,
      wrapper: LogoutButtonWrapper,
      ButtonComponent: RedAppButton,
    },
  ]
  return <React.Fragment>{children(NavbarLinks)}</React.Fragment>
}

export default NavbarLinksWrapper
